export default {
  'profileaccounts.accountsmanagement': 'إدارة حسابات البنك',
  'profileaccounts.bankname': 'اسم البنك',
  'profileaccounts.branchname': 'اسم الفرع',
  'profileaccounts.accountno': 'رقم الحساب',
  'profileaccounts.cardno': 'رقم البطاقة',
  'profileaccounts.shebano': 'رقم الشيبا',
  'profileaccounts.ismain': 'هو الحساب الافتراضي؟',
  'profileaccounts.register': 'إضافة',
  'profileaccounts.delete': 'حذف',
  'profileaccounts.deleteaccount': 'حذف حساب بنكي',
  'proprofileaccountsfile.cancel': 'إلغاء',
  'profileaccounts.deleteconfirmation': 'هل أنت متأكد من حذف حساب البنك؟',
  'profileaccounts.accountadd': 'تمت إضافة الحساب البنكي بنجاح!',
  'profileaccounts.tryagain': 'يرجى المحاولة مرة أخرى',
  'profileaccounts.enterinfo': 'يرجى إدخال معلومات حسابك',
  'profileaccounts.addaccount': 'إضافة حساب بنكي',
  'profileaccounts.cardno-account': 'رقم البطاقة / الحساب',
  'profileaccounts.accountsmanage': 'إدارة حسابات البنك',
  'profileaccounts.Textaccountsmanage':
    'يمكنك تسجيل الحساب المطلوب من خلال النموذج التالي.',
};
